import { createApp } from 'vue';
import FontSizeControl from './components/FontSizeControl.vue';
import BlogCategoryList from './enso/blog/components/BlogCategoryList.vue';
import BlogIndex from './enso/blog/components/BlogIndex.vue';
import BlogPostPreview from './enso/blog/components/BlogPostPreview.vue';
import BlogPostList from './enso/blog/components/BlogPostList.vue';
import ShareButton from './components/ShareLinks/ShareButton.vue';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import CookieNotice from './components/CookieNotice.vue';

if (document.getElementById('app')) {
  const app = createApp({});
  app.component('blog-category-list', BlogCategoryList);
  app.component('blog-index', BlogIndex);
  app.component('blog-post-preview', BlogPostPreview);
  app.component('blog-post-list', BlogPostList);
  app.component('share-button', ShareButton);
  app.component('cookie-notice', CookieNotice);
  app.mount('#app');
}

const nav = createApp({});
nav.component('font-size-control', FontSizeControl);
nav.component('headless-menu', Menu);
nav.component('headless-menu-button', MenuButton);
nav.component('headless-menu-items', MenuItems);
nav.component('headless-menu-item', MenuItem);
nav.mount('#mainNav');

// Find a parent element using a selector.
// Basically the inversion of querySelector but
// for ancestors instead of descendents
function findParent(el, query = 'A') {
  do {
    if (el.matches(query)) {
      return el;
    }
  } while ((el = el.parentNode));

  return null;
}

// Handle max checkbox limit
document.body.addEventListener('change', (event) => {
  if (event.target.matches('.multiselect input[type="checkbox"]')) {
    const fieldset = findParent(event.target, 'fieldset');

    if (!fieldset) {
      return;
    }

    checkFieldsetForMax(fieldset);
  }
});

// Check if a multiselect fieldset is at its maximum
function checkFieldsetForMax(fieldset) {
  const max = parseInt(fieldset.dataset.max, 10);

  if (!max) {
    return;
  }

  const siblings = fieldset.querySelectorAll('input[type="checkbox"]');
  const isMax = fieldset.querySelectorAll('input[type="checkbox"]:checked').length >= max;

  if (siblings.length === 0) {
    return;
  }

  Array.prototype.forEach.call(siblings, (sibling) => {
    if (sibling === event.target) {
      return;
    }

    if (sibling.checked) {
      sibling.disabled = false;
      return;
    }

    sibling.disabled = isMax;
  });
}

// Handle "other" multiselect
document.body.addEventListener('change', (event) => {
  if (
    event.target.matches('fieldset.multiselect[data-has-other] input[type="checkbox"]') &&
    event.target.value.toLowerCase() === 'other'
  ) {
    const fieldset = findParent(event.target, 'fieldset');

    if (!fieldset) {
      return;
    }

    handleMultiselectOtherOption(fieldset);
  }
});

// Check if the "other" option in a multiselect is selected
function handleMultiselectOtherOption(fieldset) {
  const question = findParent(fieldset, '[data-question-id]');

  const other_id = fieldset.dataset.otherId;

  if (!other_id) {
    return;
  }

  const other_option = fieldset.querySelector('[value=other],[value=Other]');
  const other = document.querySelector(`[data-question-id="${other_id}"]`);

  if (!other) {
    return;
  }

  if (other_option.checked) {
    showOtherOption(question, other);
  } else {
    hideOtherOption(question, other);
  }
}

// Handle other radio button
document.body.addEventListener('change', (event) => {
  if (event.target.matches('fieldset.radio[data-has-other] input[type="radio"]')) {
    const fieldset = findParent(event.target, 'fieldset');

    if (!fieldset) {
      return;
    }

    handleRadioOtherOption(fieldset);
  }
});

// Check if the "other" option in a set of radio buttons is selected
function handleRadioOtherOption(fieldset) {
  const question = findParent(fieldset, '[data-question-id]');
  const input = fieldset.querySelector('input:checked');

  if (!question || !input) {
    return;
  }

  const other_id = fieldset.dataset.otherId;

  if (!other_id) {
    return;
  }

  const other = document.querySelector(`[data-question-id="${other_id}"]`);

  if (!other) {
    return;
  }

  if (input.value.toLowerCase() === 'other') {
    showOtherOption(question, other);
  } else {
    hideOtherOption(question, other);
  }
}

// Handle load for questions with "other" option and/or max checkbox limit
window.addEventListener('load', () => {
  const fieldsets_with_max = document.querySelectorAll('fieldset[data-max]');
  Array.prototype.forEach.call(fieldsets_with_max, checkFieldsetForMax);

  const multiselect_fieldsets_with_other = document.querySelectorAll(
    'fieldset.multiselect[data-has-other]'
  );
  Array.prototype.forEach.call(multiselect_fieldsets_with_other, handleMultiselectOtherOption);

  const radio_fieldsets_with_other = document.querySelectorAll('fieldset.radio[data-has-other]');
  Array.prototype.forEach.call(radio_fieldsets_with_other, handleRadioOtherOption);
});

// Add/remove classes to show the additional "other" question
function showOtherOption(question, other) {
  other.classList.remove('hidden');
  question.classList.remove('border-b');
  question.classList.remove('pb-10');
  question.classList.remove('mb-10');
  question.classList.add('mb-5');
}

// Add/remove classes to hide the additional "other" question
function hideOtherOption(question, other) {
  other.classList.add('hidden');
  question.classList.add('border-b');
  question.classList.add('pb-10');
  question.classList.add('mb-10');
  question.classList.remove('mb-5');
}
